import React from 'react';
import {ScrollView, StyleSheet, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';

import GroupItemList from '../GroupItemList';

const storyStyle = StyleSheet.create({
  groupItemList: {
    width: '100%',
  },
});

storiesOf('partial', module).add('GroupItemList', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView expand={true}>
        <Heading level={1}>Group Item List</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>GroupItemList</Code> component is used to render a list item
          grouped items.
        </Text>
        <Spacer size={16} />
        <GroupItemList
          style={{base: storyStyle.groupItemList}}
          options={[
            {
              label: 'A Group',
              options: [{label: 'Item 1'}, {label: 'Item 2'}],
            },
            {
              label: 'Another Group',
              options: [{label: 'Item A'}, {label: 'Item B'}],
            },
          ]}
        />
        <Spacer size={6} />
        <Code>{'<GroupItemList'}</Code>
        <Code>{'  options={['}</Code>
        <Code>{'    {'}</Code>
        <Code>{"      label: 'A Group',"}</Code>
        <Code>{'      options: ['}</Code>
        <Code>{"        {label: 'Item 1'},"}</Code>
        <Code>{'        ...,'}</Code>
        <Code>{'      ],'}</Code>
        <Code>{'      ...,'}</Code>
        <Code>{'    },'}</Code>
        <Code>{'  ]}'}</Code>
        <Code>{'/>'}</Code>
      </FlexView>
    </Spacing>
  </ScrollView>
));
